export default "__VITE_ASSET__QpKltyfV__"